import {Component, OnInit, Sanitizer, ViewEncapsulation} from '@angular/core';
import {MatDialog} from "@angular/material";
import {ApiService} from "../../../service/api";
import {PayPalDialog} from "../../../components/checkout/dialog/paypal/paypal.component";
import {AdvanceDialog} from "../../../components/checkout/dialog/advance/advance.component";
import {CartService} from "../../../service/cart";
import {DomSanitizer} from "@angular/platform-browser";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'purchase-detail-cmp',
    templateUrl: './purchase.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./purchase.component.scss']
})
export class PurchaseComponent implements OnInit {

    public row: any;
    public items: any;

    constructor(public api: ApiService,
                public cart: CartService,
                public dialog: MatDialog,
                public route: ActivatedRoute,
                public sanitizer: Sanitizer,
                public domsanitizer: DomSanitizer) {

        route.params.subscribe((params) => {
            this.api.call('/orders/index/detail', {
                purchase_id: +params['id']
            }).then((row) => {
                this.setRow(row);
            });
        })
    }

    getColors(item): any[] {
        try {
            let c = JSON.parse(item.customization);
            if (c && c.colors) {
                return c.colors;
            }
        } catch (ex) {
            return [];
        }
    }

    setRow(row) {
        this.row = row;
        this.items = row.positions;
    }

    getTotal(row): number {
        var total = 0.0;
        if (row.carttotal)
            total += parseFloat(row.carttotal)

        if (row.shipmentfee)
            total += parseFloat(row.shipmentfee)

        if (row.purchasefee)
            total += parseFloat(row.purchasefee)

        return total;
    }

    ngOnInit() {
    }

    pay(method): void {
        let total = Math.round((this.row.total) * 100) / 100;
        if (method == 'paypal') {
            this.dialog.open(PayPalDialog, {
                data: {
                    payment: this.row.payment,
                    total: {
                        subtotal: total,
                        shipping: 0,
                        handling_fee: 0,
                        total: total
                    },
                    purchase: this.row
                }
            });
        } else if (method == 'advance') {
            this.dialog.open(AdvanceDialog, {
                data: {
                    payment: this.row.payment,
                    total: {
                        subtotal: total,
                        shipping: 0,
                        handling_fee: 0,
                        total: total
                    },
                    purchase: this.row
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/orders/detail/purchase.component.ts